import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from 'gatsby'

class Conecta extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-color: #fff;
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width:767px) {
              padding: 50px 0;
          }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            background-color: rgba(255,255,255,.5);                    
        `

        const Heading3 = styled.h3`
            font-size: 120px;
            font-family: Poppins;
            line-height: 120px;
            color: #000;
            font-weight: bold;
            margin-top: 100px;
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 80px;
                margin-top: 300px;
            }
            @media (max-width:767px) {
                font-size: 50px;
                line-height: 50px;
                text-align: center;
                margin: 350px 0 50px 2px;
            }
        `        
        
        const Content = styled.div`
            position: relative;
            z-index: 10;            
        `

        const Text = styled.p`
          font-size: 30px;          
          font-weight: 300;
          color: #1a1a1a;
          margin: 50px 0 350px 0;
        `

        const Submit = styled(Link)`
            display: block;
            height: 50px;
            width: 350px;
            text-decoration: none;
            position: relative;
            border: 1px solid #000;
            overflow: hidden;
            transition: .5s;            
            padding-top: 13px;
            text-align: center;
            margin: 200px 0 0 260px;
            &::after {
              position: absolute;
              content:'';
              display: inline-block;
              text-decoration: none;
              background: rgba(59,173,227,1);
              background: linear-gradient(45deg, rgba( 161, 236, 24, 1) 0%, rgba(99, 255, 0, 1) 25%, rgba( 193, 235, 24, 1) 51%, rgba( 0, 196, 99, 1) 100%);
              height: 100%;
              width:  140%;
              top: 0;
              left: 0;
              transition: .5s;
            }            
            &:hover {
              &::after {
                transform: translateX(-20%);
                text-decoration: none;
                color: #000;
              }
            }
            span {
              position: relative;
              top: 0;
              color: #000;
              font-size: 15px;              
              z-index: 10;
              text-transform: uppercase;
              text-decoration: none;
              letter-spacing: 2px;
            }
            @media (min-width:768px) and (max-width:1500px) {
              margin: 370px 0 0 60px;
            }
            @media (max-width:767px) {
              height: 5em;
              width: 17em;
              text-align: center;
              margin: 0 10vw;
            }
        `
                
        return (
            <Section id="contactenos">
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <Container>
                        <Content>
                            <Row>
                                <Col md={6}>
                                    <Heading3>
                                        Contáctenos
                                    </Heading3>
                                </Col>
                                <Col md={6}>
                                    <Submit to="/conecta">
                                        <span>
                                            Contactar al equipo de ventas
                                        </span>
                                    </Submit>
                                </Col>
                                <Col md={12}>
                                    <Text>
                                        Comuníquese a través de nuestros diferentes canales
                                    </Text>
                                </Col>
                            </Row>
                        </Content>
                    </Container>
                </Overlay>
            </Section>
        )
    }
}

export default Conecta;